import { ComparablesModalModule } from '../comparables-modal/comparables-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class ComparablesModalButtonModule {
}
ComparablesModalButtonModule.ɵfac = function ComparablesModalButtonModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ComparablesModalButtonModule)(); };
ComparablesModalButtonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ComparablesModalButtonModule });
ComparablesModalButtonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ComparablesModalModule, IconModule] });
